import { render, staticRenderFns } from "./Morningcall.vue?vue&type=template&id=a9ba2d88&scoped=true&"
import script from "./Morningcall.vue?vue&type=script&lang=js&"
export * from "./Morningcall.vue?vue&type=script&lang=js&"
import style0 from "./Morningcall.vue?vue&type=style&index=0&id=a9ba2d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ba2d88",
  null
  
)

export default component.exports